import React, { useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ThemeContext } from '../contexts/ThemeContext';
import './Modal.css';

/**
 * Reusable Modal component using portals to avoid stacking context issues
 */
function Modal({ isOpen, onClose, title, children, size = 'medium' }) {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
    event.stopPropagation();
  };

  const handleWheel = (event) => {
    event.stopPropagation();
  };

  const modalJSX = (
    <div className={`modal-backdrop ${theme}`} onClick={handleBackdropClick}>
      <div className={`modal-container ${size} ${theme}`} onWheel={handleWheel}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close-button" onClick={onClose} aria-label="Close">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="modal-content" onWheel={handleWheel}>
          {children}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalJSX, document.body);
}

export default Modal;